import { frontendURL } from '../../../helper/URLHelper';

const IntelligenceDashboard = () => import('./IntelligenceDashboard.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/intelligence-dashboard'),
    name: 'intelligence_dashboard',
    roles: ['administrator'],
    component: IntelligenceDashboard,
    meta: { hideSecondarySidebar: true },
  },
];

export default { routes };
